module.exports = __webpack_public_path__ + "static/rcc-orr-final-mobile-630017704f7881b2ec08334709ccdabb.png";